module.exports = __webpack_public_path__ + "assets/img/1201587028336_.pic_hd.70156ce5.jpg";